import { colors } from "../../../constants/colorConstants.js";

export const OrderReceiptTemplate = (
  orderData,
  user,
  fullAddress,
  allSum,
  productsInCart,
  deliveryPrice,
) => {
  const deliveryFee = parseFloat(deliveryPrice || 0);
  const hasDeferredDelivery = deliveryFee > 0;
  const chargedNow = parseFloat(allSum || 0);
  const customerFirstName = user.firstName || user.Name || "";
  const customerLastName = user.lastName || user.LastName || "";
  const customerName = `${customerFirstName} ${customerLastName}`.trim();
  const customerPhone = user.phone || user.Phone || "";
  const brandColor = colors.brandReceipt;
  const darkSlate = colors.dark;
  const now = new Date();
  const dateTimeStr =
    now.toLocaleDateString("he-IL") +
    " | " +
    now.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" });

  return `
    <div style="direction: rtl; padding: 50px; font-family: 'Rubik', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: ${darkSlate}; background-color: ${colors.white}; width: 100%; box-sizing: border-box; max-width: 850px; margin: 0 auto; line-height: 1.6; -webkit-font-smoothing: antialiased;">
        
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 50px;">
            <div style="text-align: right;">
                <img src="https://wstest.hamazon.co.il/img/iconcss/site-icon.svg" alt="המזון" style="height: 30px; width: auto; display: block; margin-bottom: 12px;" />
            </div>
            <div style="text-align: left; font-size: 13px; color: ${colors.textMuted};">
                <div style="font-weight: 700; color: ${darkSlate}; font-size: 15px; margin-bottom: 4px;">hamazon.co.il</div>
                <div>02-5327277</div>
                <div style="margin-top: 5px; font-size: 12px; color: ${colors.textPlaceholder};">${dateTimeStr}</div>
            </div>
        </div>

        <div style="display: flex; justify-content: space-between; margin-bottom: 45px; border-bottom: 1px solid ${colors.surfaceAlt}; padding-bottom: 30px;">
            <div style="flex: 1.5;">
                <div style="font-size: 18px; font-weight: 700; color: ${darkSlate}; margin-bottom: 4px;">${customerName}</div>
                <div style="font-size: 14px; color: ${colors.textMuted};">${fullAddress}</div>
                <div style="font-size: 14px; color: ${colors.textMuted};">${customerPhone}</div>
            </div>
            <div style="flex: 1; text-align: left;">
                <div style="font-size: 14px; margin-bottom: 3px;"><strong>מספר הזמנה:</strong> ${orderData.orderNumber || ""}</div>
            </div>
        </div>

        <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
            <thead>
              <tr style="border-bottom: 2px solid ${darkSlate};background-color:${brandColor};">
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate};">שם המוצר</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 100px;">ברקוד</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 110px;">מחיר יחידה</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 60px;">כמות</th>
                    <th style="padding: 12px 5px; text-align: center; font-size: 12px; font-weight: 700; color: ${darkSlate}; width: 100px;">סה"כ</th>
                </tr>
            </thead>
            <tbody>
               ${productsInCart
                 .map((p) => {
                   const unitPrice = parseFloat(p.unitPrice || p.price || 0);
                   const quantity = parseInt(p.quantity || 1);
                   const totalPaid = parseFloat(
                     p.totalPrice || unitPrice * quantity,
                   );
                   const actualUnitPrice = totalPaid / quantity;
                   const hasDiscount = unitPrice * quantity - totalPaid > 0.01;

                   return `
        <tr style="border-bottom: 1px solid ${colors.surfaceAlt};">
            <td style="padding: 18px 5px; font-size: 14px; font-weight: 500;">${p.product?.name || p.name}</td>
            <td style="padding: 18px 5px; text-align: center; font-size: 11px; color: ${colors.textPlaceholder}; font-family: monospace;">${p.product?.gtin || p.gtin || "-"}</td>
            <td style="padding: 18px 5px; text-align: center; font-size: 14px;">
                ${hasDiscount ? `<div style="text-decoration: line-through; color: ${colors.textPlaceholder}; font-size: 11px; line-height: 1;">₪${unitPrice.toFixed(2)}</div>` : ""}
                <div style="font-weight: 500;">₪${actualUnitPrice.toFixed(2)}</div>
            </td>
            <td style="padding: 18px 5px; text-align: center; font-size: 14px;">${quantity}</td>
            <td style="padding: 18px 5px; text-align: center; font-size: 14px; font-weight: 600;">₪${totalPaid.toFixed(2)}</td>
        </tr>`;
                 })
                 .join("")}
            </tbody>
        </table>

        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
            <div style="width: 320px; background-color: ${colors.bg}; padding: 25px; border-radius: 8px; border: 1px solid ${colors.border};">
                <div style="display: flex; justify-content: space-between; font-size: 17px; font-weight: 700; color: ${darkSlate};">
                    <span>סה"כ חויב כעת</span>
                    <span style="color: ${brandColor};">₪${chargedNow.toFixed(2)}</span>
                </div>
                ${
                  hasDeferredDelivery
                    ? `
                <div style="margin-top: 16px; padding-top: 14px; border-top: 1px solid ${colors.border}; font-size: 12px; line-height: 1.5; color: ${colors.textMuted}; text-align: right;">
                    דמי משלוח בסך <strong style="color: ${colors.dark};">₪${deliveryFee.toFixed(2)}</strong> אינם נגבים כעת — התשלום יבוצע ישירות לשליח בעת קבלת המשלוח.
                </div>`
                    : ""
                }
            </div>
        </div>

        <div style="margin-top: 60px; text-align: center;">
            <div style="font-size: 11px; color: ${colors.textPlaceholder}; margin-top: 6px;">
                שימו לב יתכנו סטיות קטנות בהתאם למלאי.
            </div>
        </div>
    </div>`;
};
